// extracted by mini-css-extract-plugin
export default {"playitem":"index_playitem_przqn"};